function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import styled from 'styled-components';
import TscAvatarSize from '../constants/TscAvatarSize';
import tscStyles from '../constants/TscStyles';
import { generateHSLColorFromString } from '../utils/color-generators';
import { getClassName } from '../utils/get-class-name';
var defaultTextColor = tscStyles.color.text.light;
var defaultBackgroundColor = 'transparent';
var AvatarSizeValues = {
  small: '24px',
  medium: '32px',
  mediumLarge: '36px',
  large: '64px'
};
var AvatarTextSizeValues = {
  small: '10px',
  medium: '14px',
  mediumLarge: '18px',
  large: '32px'
};
var Container = styled.div.attrs(function (props) {
  return props.testId ? {
    'data-test-id': props.testId
  } : {};
}).withConfig({
  displayName: "Avatar__Container"
})(["display:flex;align-items:center;justify-content:center;flex-shrink:0;width:", ";height:", ";position:relative;background-color:", ";border-radius:100%;overflow:hidden;"], function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, function (props) {
  return props.backgroundColor;
});
var ImageThumb = styled.img.withConfig({
  displayName: "Avatar__ImageThumb"
})(["display:block;border-radius:100%;max-width:", ";max-height:", ";"], function (props) {
  return props.maxSize;
}, function (props) {
  return props.maxSize;
});
var TextDisplay = styled.span.withConfig({
  displayName: "Avatar__TextDisplay"
})(["display:block;text-align:center;user-select:none;font-family:'Proxima Nova','proxima-nova',sans-serif;font-size:", ";color:", ";text-transform:uppercase;line-height:", ";"], function (props) {
  return props.textSize;
}, function (props) {
  return props.textColor;
}, function (props) {
  return props.height;
});

var getHSLCssColorFromString = function getHSLCssColorFromString(inputString) {
  var cssBackgroundColorValue = defaultBackgroundColor;

  if (inputString) {
    var hslColorObj = generateHSLColorFromString(inputString);
    cssBackgroundColorValue = "hsl(".concat(hslColorObj.h, ", ").concat(hslColorObj.s, ", ").concat(hslColorObj.l, ")");
  }

  return cssBackgroundColorValue;
};

var getStringToConvertToColor = function getStringToConvertToColor(userId, userDisplayName) {
  if (userId) {
    return userId;
  } else if (userDisplayName) {
    return userDisplayName;
  }

  return '';
};

var getDisplayTextFromUserDisplayName = function getDisplayTextFromUserDisplayName(userDisplayName) {
  if (!userDisplayName) {
    return '';
  }

  var removeEmailStructureChars = /\.|\+|@/g; // when email is used for display name exclude some characters from being displayed.

  var userDisplayNameSanitized = userDisplayName.replace(removeEmailStructureChars, '');
  var userDisplayNameSplitBySpace = userDisplayNameSanitized.split(' ');
  return userDisplayNameSplitBySpace.length > 1 ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  "".concat(userDisplayNameSplitBySpace[0].substr(0, 1)).concat(userDisplayNameSplitBySpace.pop().substr(0, 1)) : // non-null assertion was best way, suggested alternative is a possible null hard error
  userDisplayNameSplitBySpace[0].substr(0, 2);
};

var defaultProps = {
  size: TscAvatarSize.medium
};

var Avatar = function Avatar(props) {
  var _defaultProps$props = _objectSpread(_objectSpread({}, defaultProps), props),
      avatarImageUrl = _defaultProps$props.avatarImageUrl,
      backgroundColor = _defaultProps$props.backgroundColor,
      className = _defaultProps$props.className,
      size = _defaultProps$props.size,
      testId = _defaultProps$props.testId,
      userAltText = _defaultProps$props.userAltText,
      userDisplayName = _defaultProps$props.userDisplayName,
      userID = _defaultProps$props.userID;

  var _React$useState = React.useState({
    displayImage: true,
    textColor: defaultTextColor,
    generatedBackgroundColor: getHSLCssColorFromString(getStringToConvertToColor(userID, userDisplayName))
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      state = _React$useState2[0],
      setState = _React$useState2[1];

  React.useEffect(function () {
    setState(_objectSpread(_objectSpread({}, state), {}, {
      generatedBackgroundColor: getHSLCssColorFromString(getStringToConvertToColor(userID, userDisplayName))
    })); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userDisplayName, userID]); // deps considered

  var onImageErrorHandler = function onImageErrorHandler() {
    setState(_objectSpread(_objectSpread({}, state), {}, {
      displayImage: false
    }));
  };

  var generatedBackgroundColor = state.generatedBackgroundColor,
      textColor = state.textColor,
      displayImage = state.displayImage;
  var customBackgroundColor = backgroundColor || generatedBackgroundColor;
  var avatarBackgroundColor = avatarImageUrl && displayImage ? defaultBackgroundColor : customBackgroundColor;
  var profileImageAltText = userAltText ? userAltText : userDisplayName;
  var avatarSize = AvatarSizeValues[size];
  var textSize = AvatarTextSizeValues[size];
  var AvatarImageElement = avatarImageUrl && displayImage ? _jsx(ImageThumb, {
    className: getClassName(className, 'account-image-thumb'),
    maxSize: avatarSize,
    title: profileImageAltText,
    src: avatarImageUrl,
    alt: profileImageAltText,
    onError: onImageErrorHandler
  }) : _jsx(TextDisplay, {
    className: getClassName(className, 'avatar-text-display'),
    title: profileImageAltText,
    textColor: textColor,
    textSize: textSize,
    height: avatarSize,
    children: getDisplayTextFromUserDisplayName(userDisplayName)
  });
  return _jsx(Container, {
    className: getClassName(className, null, 'styled-avatar'),
    size: avatarSize,
    backgroundColor: avatarBackgroundColor,
    testId: testId,
    children: AvatarImageElement
  });
};

Avatar.defaultProps = defaultProps;
var AvatarTest = {
  Container: Container,
  ImageThumb: ImageThumb,
  TextDisplay: TextDisplay
};
export { Avatar, AvatarTest };
export default Avatar;